<template>
  <div class="login">
    <vue-particles
      color="#47CD88"
      :particleOpacity="0.7"
      :particlesNumber="100"
      shapeType="circle"
      :particleSize="4"
      linesColor="#47CD88"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    ></vue-particles>
    <div class="top">{{msg}}</div>
    <div class="login-content">
      <div class="inputpass">
        <el-input class="input" v-model="admin" placeholder="账号"></el-input>
        <el-input
          v-model="password"
          placeholder="密码"
          type="password"
          @keyup.enter.native="checkFun"
        ></el-input>
        <button class="denglu" @click="checkFun">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      admin: "",
      msg: "数字孪生管控系统",
      password: ""
    };
  },
  methods: {
    checkFun() {
      //验证
      var dataadmin = this.admin;
      var adtapassword = this.password;
      if (dataadmin == "admin" && adtapassword == "123") {
        this.$router.push({ path: "/home" });
      } else {
        this.$message({
          message: "请输入正确的账号或密码",
          type: "warning"
        });
      }
    }
  }
};
</script>


<style scoped>

.login {
  width: 100%;
  height: 100%;
  background: url("../assets/img/loginbig.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
}
.top {
  width: 100%;
  height: 60px;
  position: absolute;
  top: 20px;
  text-align: center;
  line-height: 60px;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(#fff, #28aecc);
  -webkit-background-clip: text;
  color: transparent;
  letter-spacing: 10px;
}
.login-content {
  width: 1200px;
  height: 824px;
  top: 100px;
  left: 50%;
  margin-left: -600px;
  position: absolute;
  background: url("../assets/img/logincenter.png") no-repeat;
  background-size: 100% 100%;
}
.inputpass {
  width: 400px;
  height: 200px;
  position: absolute;
  top: 50%;
  margin-top: -130px;
  left: 50%;
  margin-left: -200px;
}
.inputpass >>> .el-input__inner {
  background-color: #000e29;
  color: #fff;
  border: none;
  width: 300px;
  border-radius: 0;
  margin-top: 25px;
  margin-left: 50px;
  border-bottom: 1px solid #00cbd4;
  caret-color: #00cbd4;
}
.denglu {
  position: absolute;
  bottom: 0px;
  left: 50%;
  margin-left: -45px;
  width: 90px;
  height: 34px;
  border-radius: 17px;
  background-color: #000e29;
  border: 2px solid #00cbd4;
  color: #fff;
  background-size: 20px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/home/Login.vue